import {TuiEditorTool} from '@taiga-ui/addon-editor/enums';

export const defaultEditorTools = [
    TuiEditorTool.Undo,
    TuiEditorTool.Size,
    TuiEditorTool.Bold,
    TuiEditorTool.Italic,
    TuiEditorTool.Underline,
    TuiEditorTool.Align,
    TuiEditorTool.List,
    TuiEditorTool.Quote,
    TuiEditorTool.Link,
    TuiEditorTool.Anchor,
    TuiEditorTool.Color,
    TuiEditorTool.Hilite,
    TuiEditorTool.Clear,
    TuiEditorTool.Strikethrough,
    TuiEditorTool.Code,
    TuiEditorTool.Img,
    TuiEditorTool.HR,
    TuiEditorTool.Sup,
    TuiEditorTool.Sub,
    TuiEditorTool.Table,
    TuiEditorTool.Details,
];
